class AxisCameraStream
{
  constructor(mediaElement, user, password, ip, port, ws_port)
  {
    this.video_element = mediaElement;
    this.is_ready = false;
    this.pipeline = null;

    this.user = user;
    this.password = password;
    this.ip = ip;
    this.port = port || '554';
    this.ws_port = ws_port || '80';
  }

  start_video_pipeline()
  {
    if (!window.mediaStreamLibrary)
    {
      console.warn('[AxisCameraStream] mediaStreamLibrary not available');
      return;
    }

    const { pipelines } = window.mediaStreamLibrary;
    const scope = this;

    this.pipeline = new pipelines.Html5VideoPipeline({
      ws: {
        uri: `ws://${this.ip}:${this.ws_port}/rtsp-over-websocket`
        // uri: `ws://3.91.74.146:8383`
      },
      rtsp: {
        uri: `rtsp://${this.user}:${this.password}@${this.ip}:${this.port}/axis-media/media.amp?videocodec=h264&camera=1`
        // uri: 'rtsp://68.134.243.138:8554/cam'
      },
      mediaElement: this.video_element,
      auth: {
        username: this.user,
        password: this.password
      }
    });

    this.pipeline.ready.then(() =>
    {
      this.pipeline.rtsp.play();
      scope.is_ready = true;
    });
  }

  stop()
  {
    if (this.pipeline)
    {
      try
      {
        this.pipeline.close();
      }
      catch (e)
      {
        console.warn('[AxisCameraStream] Error closing pipeline:', e);
      }
      this.pipeline = null;
      this.is_ready = false;
    }
  }
}

export default AxisCameraStream;
